import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { RuntimeContext } from '../../../common/RuntimeContext';
import VerbButton from '../../shared/components/VerbButton';

const CookieBanner = (props) => {
    const { acceptOnClick, isLoginPage, loggedInUser } = props;
    const [classAnimation, setClass] = useState('fadein');

    if (
        isLoginPage() ||
        !loggedInUser ||
        !loggedInUser._id ||
        loggedInUser.cookiePolicyAccepted ||
        !useContext(RuntimeContext).pathsWeb.showCookieBanner
    ) {
        return null;
    }

    const handleClick = () => {
        acceptOnClick();
        setClass('fadeout');
    };

    return (
        <div className={cns('cookie-banner', classAnimation)}>
            <div className={'container'}>
                <div className={'row'}>
                    <div className={'cookie-banner-text col-12'}>
                        Verb Inc uses cookies to ensure the best experience on Verb. By closing this message you accept
                        our use of cookies, revised privacy policy, and terms of use.
                    </div>
                    <div className={'col-12'}>
                        <VerbButton
                            onClick={handleClick}
                            textId={'BUTTON_ACCEPT'}
                            defaultMessage={'ACCEPT'}
                            className={'mx-auto'}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

CookieBanner.propTypes = {
    loggedInUser: PropTypes.object,
    acceptOnClick: PropTypes.func,
    isLoginPage: PropTypes.func
};

export default CookieBanner;
